module.exports = __webpack_public_path__ + "img/package-search.82e45ec7.svg";